import { useState } from "react";
import { Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { Row } from "../../config/types";
import { api } from "../../services/api";
import { ErrorNotice } from "./Primitives";

export default function EmployeeLoginInvitation({ employee }: { employee: Row }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  async function send() {
    setBusy(true);
    setError("");
    setSent(false);
    try {
      await api(`/employees/${employee.id}/login-invitation`, { method: "POST", body: "{}" });
      setSent(true);
    } catch (cause) {
      setError((cause as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return <div className="employee-login-invitation">
    <div>
      <strong>{t("Application access")}</strong>
      <p>{t("Send a Google sign-in link to {{email}}.", { email: String(employee.email) })}</p>
    </div>
    <button type="button" className="button secondary" disabled={busy || employee.active === false || !employee.userId} onClick={send}>
      <Mail size={17} />{t(busy ? "Sending invitation…" : "Send login link")}
    </button>
    {sent && <p role="status">{t("Login invitation queued for delivery.")}</p>}
    {error && <ErrorNotice message={error} />}
  </div>;
}
